import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-popover",
  templateUrl: "./popover.component.html",
  styleUrls: ["./popover.component.scss", "../../../../landing.component.scss"],
})
export class PopoverComponent implements OnInit {
  constructor(private router: Router) {}

  @Output() onClose: EventEmitter<void> = new EventEmitter();
  @Input() open: boolean;

  ngOnInit(): void {}

  goTo(url: string) {
    this.router.navigate([url]);
  }

  handleClose() {
    this.onClose.emit();
  }
}
